module.exports = __webpack_public_path__ + "img/premiation-5-celular-xiaomi.9713cf93.png";